import React from 'react';
import './Reports.css';

const patientVisitsData = [
  { date: '2025-06-15', patient: 'John Doe', visitType: 'General Checkup', status: 'Completed', notes: 'All good' },
  { date: '2025-06-14', patient: 'Jane Smith', visitType: 'Follow-up', status: 'No-show', notes: 'Reschedule needed' },
  { date: '2025-06-13', patient: 'Sam Wilson', visitType: 'Consultation', status: 'Completed', notes: 'Prescribed medication' },
  { date: '2025-06-12', patient: 'Emily Clark', visitType: 'Dental', status: 'Cancelled', notes: 'Patient unavailable' },
  { date: '2025-06-11', patient: 'Michael Brown', visitType: 'Eye Checkup', status: 'Completed', notes: 'Normal vision' },
];

const prescriptionsData = [
  { date: '2025-06-15', patient: 'John Doe', medication: 'Amlodipine', dosage: '5mg daily', duration: '30 days' },
  { date: '2025-06-14', patient: 'Jane Smith', medication: 'Paracetamol', dosage: '500mg as needed', duration: '7 days' },
  { date: '2025-06-13', patient: 'Sam Wilson', medication: 'Atorvastatin', dosage: '10mg daily', duration: '60 days' },
  { date: '2025-06-11', patient: 'Michael Brown', medication: 'Metformin', dosage: '500mg twice daily', duration: '90 days' },
  { date: '2025-06-10', patient: 'Emily Clark', medication: 'Ibuprofen', dosage: '400mg as needed', duration: '5 days' },
];

const labReportsData = [
  { date: '2025-06-15', patient: 'John Doe', testType: 'Blood Test', result: 'Normal', status: 'Completed' },
  { date: '2025-06-14', patient: 'Jane Smith', testType: 'X-Ray', result: 'Fracture detected', status: 'Completed' },
  { date: '2025-06-13', patient: 'Sam Wilson', testType: 'MRI', result: 'Pending', status: 'Pending' },
  { date: '2025-06-12', patient: 'Emily Clark', testType: 'Urine Test', result: 'Normal', status: 'Completed' },
  { date: '2025-06-11', patient: 'Michael Brown', testType: 'ECG', result: 'Abnormal', status: 'Completed' },
];

const leavesData = [
  { startDate: '2025-05-01', endDate: '2025-05-03', type: 'Sick Leave', status: 'Approved', reason: 'Flu' },
  { startDate: '2025-04-15', endDate: '2025-04-15', type: 'Personal Leave', status: 'Pending', reason: 'Family Emergency' },
  { startDate: '2025-03-10', endDate: '2025-03-12', type: 'Annual Leave', status: 'Approved', reason: 'Vacation' },
  { startDate: '2025-02-20', endDate: '2025-02-22', type: 'Sick Leave', status: 'Approved', reason: 'Surgery recovery' },
  { startDate: '2025-01-05', endDate: '2025-01-06', type: 'Personal Leave', status: 'Approved', reason: 'Appointment' },
];

const appointmentsData = [
  { date: '2025-06-15', patient: 'John Doe', status: 'Completed', waitingTimeMins: 10, notes: 'On time' },
  { date: '2025-06-14', patient: 'Jane Smith', status: 'No-show', waitingTimeMins: 0, notes: 'No show' },
  { date: '2025-06-13', patient: 'Sam Wilson', status: 'Cancelled', waitingTimeMins: 0, notes: 'Cancelled by patient' },
  { date: '2025-06-12', patient: 'Emily Clark', status: 'Completed', waitingTimeMins: 20, notes: 'Late arrival' },
  { date: '2025-06-11', patient: 'Michael Brown', status: 'Completed', waitingTimeMins: 15, notes: 'Normal' },
];

const Reports = () => {
  return (
    <div className="reports-container">
      <h3>Doctor Reports</h3>

      <section className="report-section">
        <h3>Patient Visit Summary</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Visit Type</th>
              <th>Status</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {patientVisitsData.map((visit, idx) => (
              <tr key={idx}>
                <td>{visit.date}</td>
                <td>{visit.patient}</td>
                <td>{visit.visitType}</td>
                <td>{visit.status}</td>
                <td>{visit.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="report-section">
        <h3>Prescription Report</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Medication</th>
              <th>Dosage</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {prescriptionsData.map((presc, idx) => (
              <tr key={idx}>
                <td>{presc.date}</td>
                <td>{presc.patient}</td>
                <td>{presc.medication}</td>
                <td>{presc.dosage}</td>
                <td>{presc.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="report-section">
        <h3>Lab Report Statistics</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Test Type</th>
              <th>Result</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {labReportsData.map((lab, idx) => (
              <tr key={idx}>
                <td>{lab.date}</td>
                <td>{lab.patient}</td>
                <td>{lab.testType}</td>
                <td>{lab.result}</td>
                <td>{lab.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="report-section">
        <h3>Leave Summary</h3>
        <table>
          <thead>
            <tr>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Type</th>
              <th>Status</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {leavesData.map((leave, idx) => (
              <tr key={idx}>
                <td>{leave.startDate}</td>
                <td>{leave.endDate}</td>
                <td>{leave.type}</td>
                <td>{leave.status}</td>
                <td>{leave.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section className="report-section">
        <h3>Appointment Analytics</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Status</th>
              <th>Waiting Time (mins)</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {appointmentsData.map((appt, idx) => (
              <tr key={idx}>
                <td>{appt.date}</td>
                <td>{appt.patient}</td>
                <td>{appt.status}</td>
                <td>{appt.waitingTimeMins}</td>
                <td>{appt.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default Reports;
